"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'avatar.voiceAgent.description': 'Enable voice interactions with this avatar',
};
